import { Component, ViewEncapsulation } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { fuseAnimations } from '../../animations';

@Component({
    selector: 'toast-message',
    template: '',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})

export class ToastComponent {

    constructor(
        public snackBar: MatSnackBar
    ) {
    }
    // Toast message 
    showToast(message:string) {
        this.snackBar.open(message, 'Ok', {
            verticalPosition: 'top',
            duration: 2000
        });
    }
}



// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/clientdash/src/app/core/components/toast/toast.component.ts